import React, { useState, useEffect } from 'react'
import { Formik, Form, Field, useFormik } from "formik";
import * as Yup from "yup"
import axios from 'axios';
import Swal from 'sweetalert2';
import { loadCaptchaEnginge, LoadCanvasTemplate, LoadCanvasTemplateNoReload, validateCaptcha } from 'react-simple-captcha';

const MainSection = () => {
    const initialValues = {
        name: '',
        email: '',
        phone: '',
        service: '',
        project_budget: '',
        message: '',
        file: '',
        user_captcha_input:""
    }
    useEffect(() => {
        loadCaptchaEnginge(6);
    }, []);
    const [selectFile, setSelectFile] = useState('');
    const formik = useFormik({
        initialValues: initialValues,

        validationSchema: Yup.object({
            name: Yup.string()
                .min(2, 'Must be 2 characters or more')
                .max(25, 'Must be 25 characters or less')
                .matches(/^[a-zA-Z _)]+$/, "Name should contain only Alphabets")
                .required('Name is required'),
            email: Yup.string()
                .email('Invalid email address')
                .required('Email is required')
                .matches(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i, "Enter a valid E-mail Address."),
            phone: Yup.string()
                .required("Phone number is required")
                .matches(/^[0-9]+$/, "Phone Number should contain only digits")
                .min(10, 'Must be exactly 10 digits')
                .max(10, "Phone Number should not be more than 10 digits"),
            service: Yup.string().required("Service is required"),
            project_budget: Yup.string().required("Project Budget is required"),
            message: Yup.string().min('5', "Message is too short").required("Message is required"),
            user_captcha_input: Yup.string().required("Captcha is required"),
            file: Yup.mixed().required("This Field is required."),
        }),

        onSubmit: (values, { resetForm }) => {
            // console.log("Input values:", values);
            let user_captcha = document.getElementById('user_captcha_input').value;

            if (validateCaptcha(user_captcha) === true) {
                // alert('Captcha Matched');
                let timerInterval
                Swal.fire({
                    title: 'Please Wait...',
                    html: 'Your query is being submitted.',
                    timer: 10000,
                    timerProgressBar: true,
                    didOpen: () => {
                        Swal.showLoading()
                        // const b = Swal.getHtmlContainer().querySelector('b')
                        timerInterval = setInterval(() => {
                            //   b.textContent = Swal.getTimerLeft()
                        }, 100)
                    },
                    willClose: () => {
                        clearInterval(timerInterval)
                    }
                }).then((result) => {
                    /* Read more about handling dismissals below */
                    if (result.dismiss === Swal.DismissReason.timer) {
                        // console.log('I was closed by the timer')
                    }
                })
                // loadCaptchaEnginge(6); 
                const config = {
                    headers: {
                        'content-type': 'multipart/form-data'
                    }
                }
                const formData = new FormData();
                formData.append("name", values.name)
                formData.append("email", values.email)
                formData.append("phone", values.phone)
                formData.append("service", values.service)
                formData.append("project_budget", values.project_budget)
                formData.append("message", values.message)
                formData.append("file", values.file)
                // console.log(formData.values(), "formData=====")
                // axios.post('https://tapi.alobhatech.com/post-quote', formData, config)
                axios.post('https://www.alobhaapi.alobhatech.com/post-quote', formData, config)
                    .then(function (response) {
                        // console.log(response)
                        if (response.status == 200) {
                            Swal.fire(
                                'Thank you contacting us .',
                                'We will revert back to your query soon.',
                                'success'
                            )
                            // toast.success("Thank you contacting us . We will revert back to your query soon. ");
                            // setSelectFile("");
                            document.getElementById('formFileMultiple').value = "";
                            resetForm();
                        } else {
                            // console.log('before form reset.')
                            // resetForm();
                            // console.log('After form reset.')
                            Swal.fire(
                                'Please try again.',
                                'Something went wrong',
                                'error'
                            )
                            // console.log('before form reset.')
                            // resetForm();    
                            // console.log('After form reset.')
                        }
                    })
                    .catch(function (error) {
                        Swal.fire(
                            'Server Error, Please try again later.',
                            'Something went wrong',
                            'error'
                        )
                        // console.log('before form reset.')
                        resetForm();
                        // console.log('After form reset.')
                        // toast.warn(error.response.data.Message);

                    })
                document.getElementById('user_captcha_input').value = "";
            }

            else {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Captcha Does Not Match !'
                })
                document.getElementById('user_captcha_input').value = "";
            }

        }
    });
    return (
        <>
            <div className="bread-internal-cls">
                <div className="container">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><a href="index.html">Home</a></li>
                            <li className="breadcrumb-item"><a href="about.html">About Us</a></li>
                            <li className="breadcrumb-item active" aria-current="page">Get A Quote</li>
                        </ol>
                    </nav>
                </div>
            </div>
            <section className="get-quote-section" >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5">
                            <div className="getaquote-heading">
                                <h1>Get a Quote</h1>
                            </div>
                            <div className="get-a-quote-content">
                                <p>Please fill in the form and our representative will get back to you.</p>
                                <h3>500+ Project Delivered</h3>
                                <h5>With our proven experience across all industries, we SuccesfUlly Delivered 500+ Projects.</h5>
                            </div>
                            <hr style={{ background: "red" }} />
                            <div className="get-a-quote-content">
                                <h3>9+ Years of Experience Company</h3>
                                <h5>Alobha Technologies is a full-service digital solutions provider with over 9+ years of experience.</h5>
                            </div>
                            <hr style={{ backgroundColor: "#f4bd00" }} />
                            <div className="get-a-quote-content">
                                <h3>24*7 Support Service</h3>
                                <h5>At Alobha Technologies, we provide 24*7 Support Service to our clients</h5>
                            </div>
                            {/* <hr style={{ backgroundColor: "#354fe7" }} />
                            <div className="get-a-quote-content">
                                <h3>600 PROJECTS DELIVERED</h3>
                                <h5>Extensive experience in building web &
                                    mobile development applications.</h5>
                            </div> */}
                            <hr style={{ backgroundColor: "#f0f32a" }} />
                            <div className="get-a-quote-content">
                                <img src="assets/new-images/t-clients.webp" alt="" loading="lazy" />
                            </div>
                        </div>
                        <div className="col-lg-7 pb-5 pt-4">
                            <div className="get-form-dv">
                                <form onSubmit={formik.handleSubmit} className="form" id="getAQuoteMyform" method="POST"
                                    encType="multipart/form-data">
                                    <div className="form-group">
                                        <label for="exampleFormControlInput1">Your Name<span>*</span></label>
                                        <input type="text" className="form-control" id="exampleFormControlInput1" name="name" onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.name}
                                            placeholder="Your Name" required />
                                        <div className="help-block with-errors">
                                            {formik.touched.name && formik.errors.name ? (
                                                <div className='text-danger'>*{formik.errors.name}</div>
                                            ) : null}
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label for="exampleFormControlInput2">Your Email<span>*</span></label>
                                        <input type="email" className="form-control" id="exampleFormControlInput2" name="email" onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.email}
                                            placeholder="Your Email" required />
                                        <div className="help-block with-errors">
                                            {formik.touched.email && formik.errors.email ? (
                                                <div className='text-danger'>*{formik.errors.email}</div>
                                            ) : null}
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label for="exampleFormControlInput3">Your Mobile No<span>*</span></label>
                                        <input type="text" className="form-control" id="exampleFormControlInput3" maxLength={10} onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.phone}
                                            name="phone" placeholder="Your Mobile No" required />
                                        <div className="help-block with-errors">
                                            {formik.touched.phone && formik.errors.phone ? (
                                                <div className='text-danger'>*{formik.errors.phone}</div>
                                            ) : null}
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="my-1 mr-2" for="inlineFormCustomSelectPref">Interested Service</label>
                                        <select className="custom-select my-1 mr-sm-2" id="inlineFormCustomSelectPref" onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.service}
                                            name="service" required>
                                            <option>Select Interested Service</option>
                                            <option value="Website Development">Website Development</option>
                                            <option value="Mobile App Development">Mobile App Development</option>
                                            <option value="Prototype Development">Prototype Development</option>
                                            <option value="UX/UI Development">UX/UI Development</option>
                                            <option value="Hire Dedicated Development">Hire Dedicated Development</option>
                                            <option value="Discovery and Requirement Analysis">Discovery and Requirement
                                                Analysis</option>
                                            <option value="QA Services">QA Services</option>
                                            <option value="Design & Brand Identity">Design & Brand Identity</option>
                                            <option value="Design & Brand Identity">Design & Brand Identity</option>
                                            <option value="Digital marketing">Digital marketing</option>
                                            <option value="Others">Others</option>
                                        </select>
                                        <div className="help-block with-errors">
                                            {formik.touched.service && formik.errors.service ? (
                                                <div className='text-danger'>*{formik.errors.service}</div>
                                            ) : null}
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="my-1 mr-2" for="inlineFormCustomSelectPref1">Project Budget</label>
                                        <select className="custom-select my-1 mr-sm-2" id="inlineFormCustomSelectPref1" onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.project_budget}
                                            name="project_budget" required >
                                            <option >Select Project Budget</option>
                                            <option value="Below $10K">Below $10K</option>
                                            <option value="$10K - $25K">$10K - $25K</option>
                                            <option value="$25K - $75K">$25K - $75K</option>
                                            <option value="$75K - $200K">$75K - $200K</option>
                                            <option value="$200K - $500K">$200K - $500K</option>
                                            <option value="$500K and above">$500K and above</option>
                                        </select>
                                        <div className="help-block with-errors">
                                            {formik.touched.project_budget && formik.errors.project_budget ? (
                                                <div className='text-danger'>*{formik.errors.project_budget}</div>
                                            ) : null}
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label for="exampleFormControlTextarea1">Message</label>
                                        <textarea className="form-control" id="exampleFormControlTextarea1" rows="3" name="message" onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.message}
                                        ></textarea>
                                        <div className="help-block with-errors">
                                            {formik.touched.message && formik.errors.message ? (
                                                <div className='text-danger'>*{formik.errors.message}</div>
                                            ) : null}
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <div className="mb-3">
                                            <label for="formFileMultiple" className="form-label">Select or Drop your file
                                                here</label>
                                            <input className="form-control file_class" type="file" id="formFileMultiple" name="file"
                                                onChange={(e) => { formik.setFieldValue("file", e.target.files[0]) }}
                                                onBlur={formik.handleBlur}
                                            // key={formik.values.file || ''}
                                            />
                                        </div>
                                        <div className="help-block with-errors">
                                            {formik.touched.file && formik.errors.file ? (
                                                <div className='text-danger'>*{formik.errors.file}</div>
                                            ) : null}
                                        </div>
                                    </div>
                                    <div className="form-group captcha-parent-class">
                                        < LoadCanvasTemplate reloadText='<i class="fa fa-refresh rotate_cus" aria-hidden="true"></i>' />
                                    </div>
                                    <div className="form-group captcha-parent-input">
                                        <div><input placeholder="Enter Captcha Value" id="user_captcha_input" name="user_captcha_input" type="text" onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.user_captcha_input}></input></div>
                                        <div className="help-block with-errors">
                                            {formik.touched.user_captcha_input && formik.errors.user_captcha_input ? (
                                                <div className='text-danger'>*{formik.errors.user_captcha_input}</div>
                                            ) : null}
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <button type="submit" name="submit" value="SUBMIT" className="btn btn-primary btn-contact reset" id="loderButton1"><i
                                            className="fa fa-circle-o-notch fa-spin" id="loderIcon1"
                                            style={{ display: "none" }}></i>Submit Request</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default MainSection